import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config.json";
import SubTitle from "../common/SubTitle";
import RoleAssignHeader from "./RoleAssignHeader";
import RoleAssignTable from "./RoleAssignTable";
import { Box, Paper } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import NavMenu from "../../components/navbar/NavMenu";
import TitleBar from "../../components/navbar/TitleBar";
import { useTranslation } from "react-i18next";
import RoleAssignCheckbox from "./RoleAssignCheckbox";

const RoleAssign = () => {
    const navigate = useNavigate();
    const { t } = useTranslation()
    const [selectedRoleData, setSelectedRoleData] = useState([]);
    const [getAllRolesData, setGetAllRolesData] = useState([]);
    const [totalFeatures, setTotalFeatures] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const location = useLocation();
    const id = location.state?.id;

    // API calls wrapped in try-catch with proper error handling
    const getRoleById = async (id) => {
        try {
            const response = await axios.get(`${config.baseURL}/role/${id}`, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            if (error.response?.status === 401) {
                navigate("/");
                return [];
            }
            console.error("Error fetching the role by id:", error);
            throw error;
        }
    };

    const getAllTheAvailableFeatures = async () => {
        try {
            const response = await axios.get(`${config.baseURL}/feature/`, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.log("Unauthorized request");
                navigate("/");
                return;
            }
            console.error("Error fetching available features:", error);
            throw error;
        }
    };

    const assignFeatureToTheRole = async (roleId, featureIds) => {
        setIsSubmitting(true);
        try {
            const response = await axios.post(`${config.baseURL}/role/feature`, {
                roleId,
                featureId: featureIds,
            });
            return response.data;
        } catch (error) {
            console.error("Error assigning features to role:", error);
            throw error;
        } finally {
            setIsSubmitting(false);
        }
    };

    const getAllRoles = async () => {
        try {
            const response = await axios.get(`${config.baseURL}/role/organization/`, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.log("Unauthorized request");
                navigate("/");
                return;
            }
            console.error("Error fetching roles:", error);
            throw error;
        }
    };

    // Initial data fetching
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                setIsLoading(true);
                const [featuresData, rolesData] = await Promise.all([
                    getAllTheAvailableFeatures(),
                    getAllRoles(),
                ]);

                setTotalFeatures(featuresData);
                setGetAllRolesData(rolesData.roles);

                if (id) {
                    const roleData = await getRoleById(id);
                    setSelectedRoleData(roleData.role);
                }
            } catch (error) {
                console.error("Error fetching initial data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchInitialData();
    }, [id, navigate]); // Only re-run if id or navigate changes



    return (
        <>
            <SubTitle
                title="users"
                path="users > Manage Roles > Assign Features"
            />
            <Box sx={{
                maxWidth: "1360px",
                // maxHeight: "733px",
                borderRadius: "10px",
                borderWidth: 1,
                padding: "40px",
                margin: "0px 40px 40px 40px",
                gap: 20,
                background: '#FFFFFF',
                border: '1px solid #A5DCF3',
                boxShadow: '-2px 2px 5px 0px #00000040'
            }}>
                <RoleAssignHeader
                    selectedRoleData={selectedRoleData}
                    getAllRolesData={getAllRolesData}
                    totalFeatures={totalFeatures.length}
                />
            </Box>
            <Box sx={{
                maxWidth: "1360px",
                // maxHeight: "733px",
                borderRadius: "10px",
                borderWidth: 1,
                padding: "40px",
                margin: "0px 40px 40px 40px",
                gap: 20,
                background: '#FFFFFF',
                border: '1px solid #A5DCF3',
                boxShadow: '-2px 2px 5px 0px #00000040'
            }}>
                <RoleAssignCheckbox
                    getAllTheAvailableFeatures={getAllTheAvailableFeatures}
                    selectedRoleData={selectedRoleData}
                    assignFeatureToTheRole={assignFeatureToTheRole}
                    isSubmitting={isSubmitting}
                />
                {/* <RoleAssignTable
                    getAllTheAvailableFeatures={getAllTheAvailableFeatures}
                    getAllRoles={getAllRoles}
                    selectedRoleData={selectedRoleData}
                    assignFeatureToTheRole={assignFeatureToTheRole}
                    loading={isLoading}
                /> */}
            </Box>
            <Box sx={{ height: 10 }}></Box>
        </>
    );
};

export default RoleAssign;